import { getCurrentThemeConfig } from '@app/core/theme-config';
import REText from '@components/wrappedBDS/REText';
import { Panel } from '@ftdr/blueprint-components-react';
import React from 'react';

const NotOfficesFound = () => {
  return (
    <Panel
      className="w-full flex justify-center"
      shadow={getCurrentThemeConfig().noOfficesFoundShadow}
      border={getCurrentThemeConfig().noOfficesFoundBorder}
      rounded={getCurrentThemeConfig().noOfficesFoundRounded}
      borderColor="gray-300"
      padding="xl"
    >
      <REText className="my-4" variant="heading-06" id="offices__Not-Found">
        No Offices Currently Exist
      </REText>
    </Panel>
  );
};

export default NotOfficesFound;
